module.exports = __webpack_public_path__ + "components/location-background/static/background--2-fafcb22765554db720b428b0280426ce.jpg";